import React from 'react'
import {
  Sidebar,
  ListFilter,
} from './index'
import { Statistics } from './statistics'

const MainContent = () => {
  const [filtered, setFiltered] = React.useState(false)

  return (
    <section className="container mx-auto">
      <div className="flex flex-wrap -mx-4 py-10 lg:py-16">
        <aside className="hidden lg:block w-3/12 px-4">
          <Sidebar filtered={filtered} setFiltered={setFiltered}/>
        </aside>
        <main className="w-full lg:w-9/12 px-4">
          <h2 className="text-2xl text-center lg:text-left lg:text-4xl font-accent font-bold uppercase mb-5 lg:mb-10">Inisiatif Statistic</h2>
          {
            filtered &&
            <ListFilter setFiltered={setFiltered}/>
          }
          <Statistics filtered={filtered}/>
        </main>
      </div>
    </section>
  )
}

export { MainContent }
